'use client';

import type {ComponentProps} from 'react';
import {SignOutButton as ClerkSignOutButton} from '@clerk/nextjs';
import clsx from 'clsx';

export type SignOutButtonProps = {} & ComponentProps<'button'>;

export const SignOutButton = ({className, ...rest}: SignOutButtonProps) => {
	return (
		<ClerkSignOutButton>
			<button
				className={clsx(
					'inline-block cursor-pointer rounded-sm text-xl font-semibold hover:underline',
					className,
				)}
				{...rest}
			>
				Logg ut
			</button>
		</ClerkSignOutButton>
	);
};
